import { ICreditorSourceId } from "models/CreditorIdSourceModel";
import { BaseService } from "./base.service";

class CreditorIdSourceServiceInternal extends BaseService {
	getCreditorIdSourceList = async (): Promise<ICreditorSourceId[]> =>
		this.callApi<ICreditorSourceId[]>(
			`CreditorIdSource/GetCreditorIdSourceList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const CreditorIdSourceService = new CreditorIdSourceServiceInternal();
